/**
 * Site-wide copy: the brand and the buttons every page shares.
 *
 * Links use one field, `href`. Paths starting with "/" route client-side;
 * anything else (https:, mailto:) is a plain link. See `@/components/ui/Anchor`.
 */
import { GET_STARTED_URL, SIGN_IN_URL } from '@/data/links'

export const SITE_NAME = 'MeetNPlan'
export const SITE_TAGLINE = 'Meetings, rooms and visitors for modern offices.'

export const ACTIONS = {
  signIn: { label: 'Sign in', href: SIGN_IN_URL },
  demo: { label: 'Book a demo', href: '/contact' },
  // The header's one button: starts the app's create-organization wizard,
  // which opens on the 14-day free trial. Signing in stays in the footer.
  start: { label: 'Start a free trial', href: GET_STARTED_URL },
}
